export { default as LogoFull } from './logo-full';
export { default as LogoMark } from './logo-mark';



// WEBPACK FOOTER //
// ./src/icon/svgs/logos/index.js